/* =================================================================================================
 * Page « Harmonie Naturelle » — composition déplaçable sur la terre.
 *
 * Souris, doigt et stylet passent tous par les événements « pointer ». Le
 * script ne modifie que left / top, en pourcentage de la scène : la position
 * reste juste si la fenêtre change de taille, et les transformations CSS
 * (flottement, effet de prise) ne sont jamais écrasées.
 *
 * Le déplacement suit l'écart avec le point de départ du geste : l'élément ne
 * « saute » pas sous le curseur à la prise, il garde le point où on l'a saisi.
 * ===============================================================================================*/

(function () {
  'use strict';

  if (customElements.get('harmonie-terre')) return;

  class HarmonieTerre extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('.harmonie-terre__stage');
      if (!this.stage) return;

      // Plan suivant pour l'élément saisi : il passe au-dessus des autres
      // éléments DE SON PLAN, et y reste une fois posé. Les bijoux comptent à
      // partir de 1, les feuilles et cailloux à partir de 1000 (voir la
      // section) : un bijou ne passe jamais devant une feuille.
      const n = this.querySelectorAll('.harmonie-terre__item').length;
      this.plans = { dessous: n + 1, dessus: 1000 + n + 1 };
      this.prise = null;

      this.surDebut = this.surDebut.bind(this);
      this.surMouvement = this.surMouvement.bind(this);
      this.surFin = this.surFin.bind(this);

      this.querySelectorAll('.harmonie-terre__item').forEach((item) => {
        item.addEventListener('pointerdown', this.surDebut);
        item.addEventListener('pointermove', this.surMouvement);
        item.addEventListener('pointerup', this.surFin);
        item.addEventListener('pointercancel', this.surFin);
        // Filet de sécurité : pas de glisser-déposer natif de l'image.
        item.addEventListener('dragstart', (evt) => evt.preventDefault());
      });
    }

    surDebut(evt) {
      if (evt.button !== undefined && evt.button !== 0) return; // clic gauche seulement
      evt.preventDefault();
      const item = evt.currentTarget;
      const scene = this.stage.getBoundingClientRect();
      const boite = item.getBoundingClientRect();

      this.prise = {
        item: item,
        id: evt.pointerId,
        departX: evt.clientX,
        departY: evt.clientY,
        // Centre de l'élément au début du geste, en pixels dans la scène.
        centreX: boite.left + boite.width / 2 - scene.left,
        centreY: boite.top + boite.height / 2 - scene.top,
        largeur: scene.width,
        hauteur: scene.height
      };

      item.setPointerCapture(evt.pointerId);
      item.classList.add('is-dragging');
      const plan = item.dataset.plan === 'dessous' ? 'dessous' : 'dessus';
      item.style.zIndex = this.plans[plan]++;
    }

    surMouvement(evt) {
      const p = this.prise;
      if (!p || evt.pointerId !== p.id) return;
      evt.preventDefault();

      // Le centre reste dans la scène : un élément ne peut pas être perdu
      // hors de la section.
      const x = Math.min(Math.max(p.centreX + evt.clientX - p.departX, 0), p.largeur);
      const y = Math.min(Math.max(p.centreY + evt.clientY - p.departY, 0), p.hauteur);

      p.item.style.left = (x / p.largeur) * 100 + '%';
      p.item.style.top = (y / p.hauteur) * 100 + '%';
    }

    surFin(evt) {
      const p = this.prise;
      if (!p || evt.pointerId !== p.id) return;
      p.item.classList.remove('is-dragging');
      if (p.item.hasPointerCapture(p.id)) p.item.releasePointerCapture(p.id);
      this.prise = null;
    }
  }

  customElements.define('harmonie-terre', HarmonieTerre);
})();
